import { Directive, ElementRef, OnDestroy } from '@angular/core';
// @ts-ignore
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Directive({
  selector: '[baseMaskDate]',
})
export class BaseMaskDateDirective implements OnDestroy {
  mask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]; // dd.mm.yyyy
  maskedInputController;

  constructor(private element: ElementRef) {
    this.maskedInputController = textMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask,
    });
  }

  ngOnDestroy(): void {
    this.maskedInputController.destroy();
  }
}
